import {CATEGORIES} from "../../Config/ApiUrl";
import {deleteAction, editAction} from "../../Helpers/TableAction";
import {createdFilter} from "../../Helpers/TableFIlter";
import {actionColumn} from "../../Helpers/TableCommonColumn";
import DatatableHelperMixin from "../../Mixins/DatatableHelperMixin";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$allLabel('categories'),
                url: CATEGORIES,
                responsive: true,
                columns: [
                    {
                        title: this.$t('category'),
                        type: 'component',
                        componentName: 'app-category-media',
                        key: 'logo',
                    },
                    {
                        title: this.$t('product'),
                        type: 'text',
                        key: 'product_count',
                    },
                    {
                        title: this.$t('sub_categories'),
                        type: 'expandable-column',
                        key: 'sub_categories',
                        className: 'success',
                        showTitle: this.$t('show'),
                        hideTitle: this.$t('hide'),
                        componentName: 'app-sub-categories',
                        showIcon: 'eye', // not required
                        hideIcon: 'eye-off', // not required
                        modifier: (value, row) => {
                            return {
                                visible: true,
                                expandable: true
                            };
                        }
                    },
                    actionColumn(),
                ],
                filters: [
                    createdFilter()
                ],
                actionType: "dropdown",
                actions: [
                    editAction(this.$can('update_categories'), CATEGORIES),
                    deleteAction(this.$can('delete_categories'), CATEGORIES)
                ],
                rowLimit: 10,
                paginationType: "pagination"
            },
            isModalActive: false,
            selectedUrl: null,
            confirmationModalActive: false
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.key === 'edit') {
                this.isModalActive = true;
                this.selectedUrl = `${this.apiUrl.CATEGORIES}/${row.id}`
            }else {
                this.getAction(row, action, active)
            }
        }
    }
}